enum UserType {
  COUNTY_USER = 'COUNTY_USER',
  STATE_USER = 'STATE_USER',
}

export default UserType;
